import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { adminLogin, setToken } from "../lib/adminApi";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await adminLogin(email, password);
      setToken(data.token);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Échec de la connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-navy px-5">
      <div className="w-full max-w-md">
        {typeof window !== "undefined" && !window.location.hostname.endsWith("tireragroup.com") && (
          <div data-testid="test-env-banner-login" className="mb-6 rounded-2xl bg-amber-500 px-4 py-3 text-center text-sm font-semibold text-black">
            ⚠️ SITE DE TEST — pour gérer vos vraies données, connectez-vous sur{" "}
            <a href="https://tireragroup.com/admin" className="underline">tireragroup.com/admin</a>
          </div>
        )}
        <div className="flex items-center gap-3 justify-center mb-8">
          <Logo className="h-10 w-10" light />
          <span className="font-display font-bold text-xl text-white">TIRERA GROUP</span>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="rounded-3xl border border-white/10 bg-white/[0.04] p-8">
          <div className="flex items-center gap-2 text-white/60 text-xs font-semibold uppercase tracking-wider">
            <Lock size={14} /> Administration
          </div>
          <h1 className="mt-3 font-display font-semibold text-2xl text-white">Connexion</h1>
          <div className="mt-6 space-y-4">
            <div>
              <label className="mb-2 block text-sm font-medium text-white/80">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                className="w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white placeholder-white/40 outline-none focus:border-white/40"
                placeholder="email@exemple.com"
              />
            </div>
            <div>
              <label className="mb-2 block text-sm font-medium text-white/80">Mot de passe</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white placeholder-white/40 outline-none focus:border-white/40"
                placeholder="••••••••"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-6 w-full rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-navy hover:bg-white/90 transition-colors disabled:opacity-60"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
          <a
            href="/admin/forgot-password"
            data-testid="admin-forgot-link"
            className="mt-4 block text-center text-sm text-white/60 hover:text-white transition-colors"
          >
            Mot de passe oublié ?
          </a>
        </form>
      </div>
    </main>
  );
}
